import { render, staticRenderFns } from "./Control_menu.vue?vue&type=template&id=41227733&scoped=true&lang=pug&"
import script from "./Control_menu.vue?vue&type=script&lang=js&"
export * from "./Control_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41227733",
  null
  
)

export default component.exports